import { Form, Button } from "antd";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import CreationFormItems from "../../../../../components/creation/CreationFormItems";
import {
  INPUT_MAX_LENGTH,
  URLS,
} from "../../../../../utils-creation/constants";
import { serializeData } from "../../../../../utils-creation/utils";
import {
  Creation,
  CreationInputLengths,
} from "../../../../../utils-creation/types";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "app/store";
import { postCreation } from "../creationPanelSlice";
import "./index.css";

export default function AddCreation() {
  const [inputLengths, setInputLengths] = useState<CreationInputLengths>({
    title: 0,
    url: 0,
    title_in_english: 0,
    media: 0,
    premiere_venue: 0,
    premiere_venue_type: 0,
    premiere_city_country: 0,
    non_premiere_1_venue: 0,
    non_premiere_1_venue_type: 0,
    non_premiere_1_city_country: 0,
    non_premiere_2_venue: 0,
    non_premiere_2_venue_type: 0,
    non_premiere_2_city_country: 0,
    description: 0,
    creator: 0,
    director: 0,
    composer: 0,
    editor: 0,
    curator: 0,
    producer: 0,
    performers: 0,
    writers: 0,
    dramaturg: 0,
    cinematographer: 0,
    director_of_photography: 0,
    technical_director: 0,
    lighting_director: 0,
    set_designer: 0,
    video_production: 0,
    costume_designer: 0,
    installation_designer: 0,
    sound_designer: 0,
    production_designer: 0,
    production_engineer: 0,
    stage_manager: 0,
    distributor: 0,
    additional_credits: 0,
  });
  const history = useHistory();
  const dispatch = useDispatch();

  const { user } = useSelector((state: RootState) => state.authentication);

  const onFinish = (values: Creation) => {
    serializeData(values);
    dispatch(
      postCreation({
        payload: values,
        callback: redirectToCreationPage,
      })
    );
  };

  const onValuesChange = (changedValues: any, allValues: any) => {
    const key = Object.keys(changedValues)[0];
    if (
      typeof changedValues[key] === "string" &&
      Object.keys(INPUT_MAX_LENGTH).includes(key)
    )
      setInputLengths((prevInputLengths: CreationInputLengths) => ({
        ...prevInputLengths,
        [key]: changedValues[key].length,
      }));
  };

  const redirectToCreationPage = () => {
    user !== null && history.push(URLS.RESEARCH_CREATION_ROOT);
  };

  return (
    <Form
      className="sub-heading-font add-creation"
      labelCol={{
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 5 },
        lg: { span: 4 },
      }}
      wrapperCol={{
        xs: { span: 24 },
        sm: { span: 24 },
        md: { span: 16 },
        lg: { span: 17 },
      }}
      onFinish={onFinish}
      onValuesChange={onValuesChange}
      scrollToFirstError={{ behavior: "smooth" }}
    >
      <CreationFormItems inputLengths={inputLengths} formType="ADD" />

      <Form.Item wrapperCol={{ offset: 8, span: 8 }}>
        <Button
          type="primary"
          htmlType="submit"
          style={{ marginRight: "15px" }}
        >
          SAVE
        </Button>
        <Button htmlType="button" onClick={redirectToCreationPage}>
          CANCEL
        </Button>
      </Form.Item>
    </Form>
  );
}
